export default __webpack_public_path__ + "static/media/BLR31.a56fe34d.jpg";